module.exports = __webpack_public_path__ + "img/slide00_m.ccb800fe.jpg";